export const AUTH_USER_KEY = "__user__";
export const TOKEN_KEY = "__token__";
